import type { AppRoute } from '#/routing/classes/AppRoute';

type Args<T extends AppRoute<string, string, string>> = {
  url: string;
  route: T;
};

export function getAppRouteSearchParams<
  T extends AppRoute<string, string, string>,
>({ url, route }: Args<T>): Partial<Record<T['searchParams'][number], string>> {
  const { searchParams } = new URL(url);

  const result: Record<string, unknown> = {};
  for (const itSearchParam of route.searchParams) {
    result[itSearchParam] = searchParams.get(itSearchParam);
  }

  return result as Partial<Record<T['searchParams'][number], string>>;
}
